import genericStore from "../generic_store";

export default {
  namespaced: genericStore.namespaced,
  state: {
    ...genericStore.state,
    endpoint: "rent_orders",
    object: "rent_order",
    header: [
      { text: "Precio", value: "price" },
      { text: "Descuento", value: "coupon_amount_paid" },
      { text: "Tiempo de uso", value: "time_quantity" },
      { text: "Estado del Pago", value: "status_payment" },
      { text: "Host", value: "user" },
      { text: "Spot", value: "spot" },
      { text: "Liquidate", value: "liquidate", sortable: false },
      //{ text: "Actions", value: "actions", sortable: false }
    ],
    options: {
      sortBy: ["_id"],
      sortDesc: [false],
    },
  },
  mutations: {
    ...genericStore.mutations,
  },
  actions: {
    ...genericStore.actions,
  },
  getters: {
    ...genericStore.getters,
  },
};
